import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { useTranslation } from 'react-i18next';

// style
import styles from './style';

const useStyles = makeStyles(styles);

export default function WlLegend() {
  const { t } = useTranslation();
  const classes = useStyles();

  function FormRow() {
    return (
      <>
        <Grid item xs className={classes.boxLevel}>
          <Box>
            <Box id="wl-legend-1" p={1} className={`${classes.color} ${classes.one}`}>{'<=10'}</Box>
            <Box p={1} className={classes.title}>{t('น้อยวิกฤต')}</Box>
          </Box>
        </Grid>
        <Grid item xs className={classes.boxLevel}>
          <Box>
            <Box id="wl-legend-2" p={1} className={`${classes.color} ${classes.two}`}>{'>10-30'}</Box>
            <Box p={1} className={classes.title}>{t('น้อย')}</Box>
          </Box>
        </Grid>
        <Grid item xs className={classes.boxLevel}>
          <Box>
            <Box id="wl-legend-3" p={1} className={`${classes.color} ${classes.three}`}>{'>30-70'}</Box>
            <Box p={1} className={classes.title}>{t('ปกติ')}</Box>
          </Box>
        </Grid>
        <Grid item xs className={classes.boxLevel}>
          <Box>
            <Box id="wl-legend-4" p={1} className={`${classes.color} ${classes.four}`}>{'>70-100'}</Box>
            <Box p={1} className={classes.title}>{t('>มาก')}</Box>
          </Box>
        </Grid>
        <Grid item xs className={classes.boxLevel}>
          <Box>
            <Box id="wl-legend-5" p={1} className={`${classes.color} ${classes.five}`}>{'>100'}</Box>
            <Box p={1} className={classes.title}>{t('ล้นตลิ่ง')}</Box>
          </Box>
        </Grid>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <FormRow />
      </Grid>
    </div>
  );
}
